const TAG_REGEX = /<[^>]*>/g;

export function stripHtml(value: string): string {
  if (!value) return "";
  return value.replace(TAG_REGEX, "").trim();
}
